export default {
    "types": {
        "1": {
            "showName": "Создана"
        },
        "200": {
            "showName": "Завершена"
        }
    }
}